import React from "react";

import WorkOrderRoutingTableRow from "./WorkOrderRoutingTableRow";

const WorkOrderRoutingTableBody = ({
  disabled,
  options = [],
  remove = () => {},
  fields = [],
}) => {
  return (
    <>
      {fields?.map((item, idx) => (
        <WorkOrderRoutingTableRow
          key={item.id}
          idx={idx}
          item={item}
          remove={remove}
          disabled={disabled}
          options={options}
        />
      ))}
    </>
  );
};

export default WorkOrderRoutingTableBody;
